import httpService from 'src/services/app/http.service'
import { log } from 'src/services/app/log.service'
import { AUTH_ENDPOINTS } from 'src/services/consts/api.const'
import { refactorUser } from 'src/services/helpers/auth.helper'

export const authService = {
  login,
  googleLogin,
}

async function login(credentials = {}) {
  const user = await httpService.post(AUTH_ENDPOINTS.LOGIN, credentials)
  if (!user) throw 'No user'
  log.success('Login success', { user })
  return refactorUser(user)
}

async function googleLogin(token) {
  const user = await httpService.post(AUTH_ENDPOINTS.GOOGLE_LOGIN, { json_web_token: token })
  if (!user) throw 'No user'
  log.success('Login success', { user })
  return refactorUser(user)
}
